<template>
  <v-container
    id="eligibilityGroupTab"
    class="pa-0"
  >
    <base-resource-grid
      ref="resourceGrid"
      color="green"
      icon="mdi-trophy-outline"
      plural-name="Eligibility Group"
      singular-name="Eligibility Group"
      allow-expand
      :headers="gridHeaders"
      :resource="eligibilityGroupResource"
      :fetch-method="getEligibilityGroup"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
      @item:deleted="itemChanged"
    >
      <template v-slot:rowExpand="bindings">
        <base-audit-container
          v-show="bindings.details.expandAction !== 'details'"
          :item="bindings.details.item"
        />
        <eligibility-group-details
          v-show="bindings.details.expandAction === 'details'"
          :open-enrollment="openEnrollment"
          :eligibility-group="bindings.details.item"
        />
      </template>
      <template
        v-slot:editForm="bindings"
        class="pa-0"
      >
        <eligibility-group-edit
          v-model="bindings.editedItem"
          class="pa-0"
          :open-enrollment="openEnrollment"
          :form-errors="bindings.formErrors"
          :disabled="disabled"
        />
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oeEligibilityGroupHistory/"
      id-field="oeEligibilityGroupId"
      title-field="EligibilityGroup"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'EligibilityGroupTab',

    components: {
      EligibilityGroupEdit: () => import('./EligibilityGroupEdit'),
      EligibilityGroupDetails: () => import('./EligibilityGroupDetails'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      gridHeaders: [
        {
          text: 'Eligibility Group',
          value: 'eligibilityGroup',
        },
      ],

      historyColumns: [
        {
          text: 'Eligibility Group',
          value: 'eligibilityGroup',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
        {
          color: 'amber',
          icon: 'mdi-account-supervisor',
          action: 'details',
        },
      ],

      eligibilityGroupResource: new TroodyApi('oeEligibilityGroup/'),

      historyItem: null,

      currentAction: 'history',
    }),

    methods: {
      getEligibilityGroup () {
        return this.eligibilityGroupResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        // If we are already on history, show details
        if (action === 'history' && this.currentAction === 'history') {
          this.historyItem = data
        }

        this.$refs.resourceGrid.expand(action, data)
        this.currentAction = action
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>
